export const enum ExternalInvoiceStatus {
    Received = 0,
    Accepted = 1,
    Rejected = 2,
    Paid = 10,
}

export const enum ExternalInvoiceType {
    MaterialsOrder = 0,
    SubcontractorSettlement = 1,
    Other = 10,
}
